import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { formatRelative } from 'date-fns';
import { getCurrentDateLocale } from '../../application/localisation/localization';
import { useEffect } from 'react';
import { useStudy } from 'src/helpers/hooks/useStudy';
import { getDoctorStudyByIdQueryKey } from 'src/services/api/api-client/StudyQuery';
import { useRevalidator } from 'react-router-dom';

export function useSyncInProgress(studyId: number | undefined): { result: boolean; date: string } {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const study = useStudy();
  const revalidator = useRevalidator();

  useEffect(() => {
    if (!study?.isSyncInProgress) return;

    const timeoutId = setTimeout(() => {
      queryClient.invalidateQueries(getDoctorStudyByIdQueryKey(studyId!));
      revalidator.revalidate();
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [queryClient, study]);

  return {
    result: !!study?.isSyncInProgress,
    date: study?.lastSuccessSyncDate
      ? formatRelative(study.lastSuccessSyncDate, Date.now(), getCurrentDateLocale())
      : t('Common_Never'),
  };
}
